import { render, staticRenderFns } from "./NotificationCard.vue?vue&type=template&id=21d388e6&scoped=true&"
import script from "./NotificationCard.vue?vue&type=script&lang=ts&"
export * from "./NotificationCard.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationCard.vue?vue&type=style&index=0&id=21d388e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d388e6",
  null
  
)

export default component.exports